<basket-supplier-ui
    [companySetting]="companySetting"
    [supplierBasket]="supplierBasket$ | async"
    [basketItems]="basketItems$ | async"
    [isEditableStep]="isEditableStep"
    [basketToggleStatus]="basketToggleStatus"
    [deliveryCondition]="deliveryCondition$ | async"
    [paymentTerms]="paymentTerms$ | async"
    [isPaymentTermRequired]="isPaymentTermRequired$ | async"
    [frameContracts]="frameContracts$ | async"
    [generalAgreementRequired]="(isGeneralAgreementRequired$ | async) ?? false"
    [budgetOverruns]="budgetOverruns"
    [resolvedPurchasingGroups]="resolvedPurchasingGroups"
    [purchasingGroupVisible]="purchasingGroupVisible"
    [companyCodeId]="companyCodeId"
    (basketItemDeleted)="deleteBasketItem($event)"
    (attachmentOpened)="openAttachmentDialog($event)"
    (supplierCommentSaved)="saveSupplierComment($event)"
    (attachmentFileDeleted)="deleteAttachmentFile($event)"
    (personCommentSaved)="savePersonComment($event)"
    (productNumberValidationMessageShown)="onShowProductNumberValidationMessage($event)"
    (desiredDeliveryDateValidated)="onDesiredDeliveryDateValidated($event)"
    (accountingValidated)="onAccountingValidated($event)"
    (classificationValidated)="onClassificationValidated($event)"
    (materialGroupValidated)="onMaterialGroupValidated($event)"
    (siteValidated)="onSiteValidated($event)"
    (deliveryConditionCreated)="saveDeliveryCondition($event)"
    (deliveryConditionUpdated)="saveDeliveryCondition($event)"
    (deliveryConditionDeleted)="onDeleteDeliveryCondition()"
    (paymentTermSelectionOpened)="onPaymentTermSelectionOpen()"
    (paymentTermDeleted)="deleteCurrentPaymentTerm()"
    (paymentTermValidated)="onPaymentTermValidated($event)"
    (frameContractSelectionChanged)="onFrameContractSelectionChanged($event)"
    (frameContractValidated)="onFrameContractValidated($event)"
></basket-supplier-ui>
